/** Canonical in-app profile destination (Apple-compliant UnifiedProfileView + completion modal). */
export function appBetaProfileUrl(reason?: 'upgrade' | 'park_photo_upload'): string {
  const params = new URLSearchParams({ tab: 'profile' })
  if (reason) params.set('reason', reason)
  return `/app-beta?${params.toString()}`
}
